import React from 'react';

import { Grid, Stack, Typography } from '@mui/material';
import dynamic from 'next/dynamic';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';

import { primaryColors } from '~components/theme/styles/colors';

import { RoadmapPanel, VerticalRoadmapPanel } from '../roadmap/panel';
import SlideWrapper from '../SlideWrapper';

const MobileFadingContainer = dynamic(
  () =>
    import('src/v2/components/ui/containers/mobile').then(
      ({ MobileFadingContainer }) => MobileFadingContainer,
    ),
  { ssr: false },
);

function ShortRoadmapSlide() {
  return (
    <SlideWrapper>
      <Stack spacing={4}>
        <Typography variant={'h4'} color={primaryColors[50]}>
          Roadmap
        </Typography>
        <Typography variant={'body1'} color={primaryColors[400]}>
          VST is collateralized by a variety of collaterals. All collaterals onboarded go through a rigorous
          onboarding process and the respective risks are continuously monitored.
        </Typography>
      </Stack>
      <MobileFadingContainer
        app={
          <Grid container direction={'row'} spacing={8} mt={4}>
            <Grid item xs={4}>
              <RoadmapPanel
                quarterText="Q4 2022"
                quarterDescription="Vesta Trader: an internally-used DEX aggregator, was created"
              />
            </Grid>
            <Grid item xs={4}>
              <RoadmapPanel
                quarterText="Q1 2023"
                quarterDescription="VST Saving Module, VSTA Staking Module"
                current
              />
            </Grid>
            <Grid item xs={4}>
              <RoadmapPanel
                quarterText="Q2 2023"
                quarterDescription="Further expansion of VST use cases, making VST the go-to stable on Arbitrum"
              />
            </Grid>
          </Grid>
        }
        mobile={
          <Grid container direction={'row'} spacing={8} mt={4}>
            <Grid item xs={12}>
              <VerticalRoadmapPanel
                stepTitle="Q4 2022"
                subtitleVariant={'body2'}
                subtitle="Vesta Trader: an internally-used DEX aggregator, was created"
                highlight="completed"
              />
            </Grid>
            <Grid item xs={12}>
              <VerticalRoadmapPanel
                stepTitle="Q1 2023"
                subtitleVariant={'body2'}
                subtitle="VST Saving Module, VSTA Staking Module"
                highlight="current"
              />
            </Grid>
            <Grid item xs={12}>
              <VerticalRoadmapPanel
                stepTitle="Q2 2023"
                highlight="upcoming"
                subtitleVariant={'body2'}
                subtitle="Further expansion of VST use cases, making VST the go-to stable on Arbitrum"
              />
            </Grid>
          </Grid>
        }
      />

      <ButtonWithIcon iconType="asterisk" sx={{ width: 280, mt: 8 }}>
        CHECK OUT OUR FULL ROADMAP
      </ButtonWithIcon>
    </SlideWrapper>
  );
}

export default ShortRoadmapSlide;
